module.exports = __webpack_public_path__ + "src/assets/img/cmdArmQuiet.a036598f.svg";